import { URLS } from '@constants'

import { commonAPI } from './common.api'

export const configsApi = commonAPI.injectEndpoints({
  endpoints: build => ({
    importConfigEntity: build.mutation<void, string>({
      query: body => ({
        url: URLS.FRONT_CFG + `/configs/import`,
        method: 'POST',
        body,
        headers: {
          'Content-Type': 'application/xml',
        },
      }),
      invalidatesTags: ['AllConfigs'],
    }),
    exportConfigEntity: build.mutation<string, { configCode: string; id: number }>({
      query: ({ configCode, id }) => ({
        url: URLS.FRONT_CFG + `/configs/export/object/${configCode}/id/${id}`,
        method: 'GET',
        responseHandler: 'text',
      }),
    }),
    exportAllConfigEntity: build.mutation<string, { configCode: string }>({
      query: ({ configCode }) => ({
        url: URLS.FRONT_CFG + `/configs/dump/object/${configCode}`,
        method: 'GET',
        responseHandler: 'text',
      }),
    }),
  }),
})

export const {
  useImportConfigEntityMutation,
  useExportConfigEntityMutation,
  useExportAllConfigEntityMutation,
} = configsApi
